import React from 'react';
import { hospedesMock } from './mock';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Avatar, Stack, Typography } from '@mui/material';

export default function Hospedes() {
  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Hóspede</TableCell>
            <TableCell>Documento</TableCell>
            <TableCell>Telefone</TableCell>
            <TableCell>E-mail</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {hospedesMock.map((h) => (
            <TableRow key={h.id} hover>
              <TableCell>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Avatar sx={{ width: 28, height: 28 }}>{h.nome?.[0] || '?'}</Avatar>
                  <Typography variant="body2">{h.nome}</Typography>
                </Stack>
              </TableCell>
              <TableCell>{h.documento}</TableCell>
              <TableCell>{h.telefone}</TableCell>
              <TableCell>{h.email}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
